
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('backend/localStorage',["require", "exports", '../generic/indexed_filesystem', '../generic/preload_file', '../core/node_fs_stats', '../core/buffer', '../generic/file_index', '../core/string_util', '../core/api_error', '../core/node_path', '../core/browserfs'], function(require, exports, indexed_filesystem, preload_file, node_fs_stats, buffer, file_index, string_util, api_error, node_path, browserfs) {
    var Buffer = buffer.Buffer;
    var Stats = node_fs_stats.Stats;
    var FileType = node_fs_stats.FileType;
    var ApiError = api_error.ApiError;
    var ErrorCode = api_error.ErrorCode;
    var path = node_path.path;

    var LocalStorageAbstract = (function (_super) {
        __extends(LocalStorageAbstract, _super);
        function LocalStorageAbstract() {
            _super.call(this, new file_index.FileIndex());
            for (var i = 0; i < window.localStorage.length; i++) {
                var path = window.localStorage.key(i);
                if (path[0] !== '/') {
                    continue;
                }
                var data = window.localStorage.getItem(path);
                if (data == null) {
                    data = '';
                }
                var len = this._getFileLength(data);
                var inode = new file_index.FileInode(new Stats(32768 /* FILE */, len));
                this._index.addPath(path, inode);
            }
        }
        LocalStorageAbstract.prototype._getFile = function (path, flags, stats) {
            var data = window.localStorage.getItem(path);
            if (data === null) {
                return null;
            }
            return this._convertFromBinaryString(path, data, flags, stats);
        };

        LocalStorageAbstract.prototype._syncSync = function (path, data, stats) {
            var dataStr = this._convertToBinaryString(data, stats);
            try  {
                window.localStorage.setItem(path, dataStr);
                this._index.addPath(path, new file_index.FileInode(stats));
            } catch (e) {
                throw new ApiError(11 /* ENOSPC */, "Unable to sync " + path);
            }
        };

        LocalStorageAbstract.prototype.empty = function () {
            window.localStorage.clear();
            this._index = new file_index.FileIndex();
        };

        LocalStorageAbstract.prototype.getName = function () {
            return 'localStorage';
        };

        LocalStorageAbstract.isAvailable = function () {
            return typeof window !== 'undefined' && window !== null && typeof window['localStorage'] !== 'undefined';
        };

        LocalStorageAbstract.prototype.diskSpace = function (path, cb) {
            var storageLimit = 5242880;

            var usedSpace = 0;
            for (var i = 0; i < window.localStorage.length; i++) {
                var key = window.localStorage.key(i);
                usedSpace += key.length * 2;
                var data = window.localStorage.getItem(key);
                usedSpace += data.length * 2;
            }

            if (typeof window.localStorage['remainingSpace'] !== 'undefined') {
                var remaining = window.localStorage.remainingSpace;

                storageLimit = usedSpace + remaining;
            }
            cb(storageLimit, usedSpace);
        };

        LocalStorageAbstract.prototype.isReadOnly = function () {
            return false;
        };

        LocalStorageAbstract.prototype.supportsLinks = function () {
            return false;
        };

        LocalStorageAbstract.prototype.supportsProps = function () {
            return true;
        };

        LocalStorageAbstract.prototype.unlinkSync = function (path) {
            _super.prototype.unlinkSync.call(this, path);
            window.localStorage.removeItem(path);
        };

        LocalStorageAbstract.prototype._truncate = function (path, flags, stats) {
            stats.size = 0;
            return new LocalStorageFile(this, path, flags, stats);
        };

        LocalStorageAbstract.prototype._fetch = function (path, flags, stats) {
            return this._getFile(path, flags, stats);
        };

        LocalStorageAbstract.prototype._create = function (path, flags, inode) {
            return new LocalStorageFile(this, path, flags, inode.getData());
        };

        LocalStorageAbstract.prototype._rmdirSync = function (p, inode) {
            var files = inode.getListing();
            var sep = path.sep;
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                window.localStorage.removeItem("" + p + sep + file);
            }
        };

        LocalStorageAbstract.prototype._convertToBinaryString = function (data, stats) {
            throw new ApiError(14 /* ENOTSUP */, 'LocalStorageAbstract is an abstract class.');
        };
        LocalStorageAbstract.prototype._convertFromBinaryString = function (path, data, flags, stats) {
            throw new ApiError(14 /* ENOTSUP */, 'LocalStorageAbstract is an abstract class.');
        };
        LocalStorageAbstract.prototype._getFileLength = function (data) {
            throw new ApiError(14 /* ENOTSUP */, 'LocalStorageAbstract is an abstract class.');
        };
        return LocalStorageAbstract;
    })(indexed_filesystem.IndexedFileSystem);
    exports.LocalStorageAbstract = LocalStorageAbstract;

    var LocalStorageModern = (function (_super) {
        __extends(LocalStorageModern, _super);
        function LocalStorageModern() {
            _super.call(this);
        }
        LocalStorageModern.prototype._convertToBinaryString = function (data, stats) {
            var dataStr = data.toString('binary_string');

            var headerBuff = new Buffer(18);
            headerBuff.writeUInt16BE(stats.mode, 0);

            headerBuff.writeDoubleBE(stats.mtime.getTime(), 2);
            headerBuff.writeDoubleBE(stats.atime.getTime(), 10);
            var headerDat = headerBuff.toString('binary_string');
            dataStr = headerDat + dataStr;
            return dataStr;
        };

        LocalStorageModern.prototype._convertFromBinaryString = function (path, data, flags, stats) {
            var headerBuff = new Buffer(data.substr(0, 10), 'binary_string');
            data = data.substr(10);
            var buffer = new Buffer(data, 'binary_string');
            var file = new LocalStorageFile(this, path, flags, stats, buffer);
            file._stat.mode = headerBuff.readUInt16BE(0);
            file._stat.mtime = new Date(headerBuff.readDoubleBE(2));
            file._stat.atime = new Date(headerBuff.readDoubleBE(10));
            return file;
        };

        LocalStorageModern.prototype._getFileLength = function (data) {
            if (data.length > 10) {
                return string_util.FindUtil('binary_string').byteLength(data.substr(10));
            } else {
                return 0;
            }
        };
        return LocalStorageModern;
    })(LocalStorageAbstract);
    exports.LocalStorageModern = LocalStorageModern;

    var LocalStorageOld = (function (_super) {
        __extends(LocalStorageOld, _super);
        function LocalStorageOld() {
            _super.call(this);
        }
        LocalStorageOld.prototype._convertToBinaryString = function (data, stats) {
            var dataStr = data.toString('binary_string_ie');
            var headerBuff = new Buffer(18);
            headerBuff.writeUInt16BE(stats.mode, 0);

            headerBuff.writeDoubleBE(stats.mtime.getTime(), 2);
            headerBuff.writeDoubleBE(stats.atime.getTime(), 10);
            var headerDat = headerBuff.toString('binary_string_ie');
            dataStr = headerDat + dataStr;
            return dataStr;
        };

        LocalStorageOld.prototype._convertFromBinaryString = function (path, data, flags, stats) {
            var headerBuff = new Buffer(data.substr(0, 18), 'binary_string_ie');
            data = data.substr(18);
            var buffer = new Buffer(data, 'binary_string_ie');
            var file = new LocalStorageFile(this, path, flags, stats, buffer);
            file._stat.mode = headerBuff.readUInt16BE(0);
            file._stat.mtime = new Date(headerBuff.readDoubleBE(2));
            file._stat.atime = new Date(headerBuff.readDoubleBE(10));
            return file;
        };

        LocalStorageOld.prototype._getFileLength = function (data) {
            if (data.length > 0) {
                return data.length - 18;
            } else {
                return 0;
            }
        };
        return LocalStorageOld;
    })(LocalStorageAbstract);
    exports.LocalStorageOld = LocalStorageOld;

    var LocalStorageFile = (function (_super) {
        __extends(LocalStorageFile, _super);
        function LocalStorageFile(_fs, _path, _flag, _stat, contents) {
            _super.call(this, _fs, _path, _flag, _stat, contents);
        }
        LocalStorageFile.prototype.syncSync = function () {
            this._fs._syncSync(this._path, this._buffer, this._stat);
        };

        LocalStorageFile.prototype.closeSync = function () {
            this.syncSync();
        };
        return LocalStorageFile;
    })(preload_file.PreloadFile);
    exports.LocalStorageFile = LocalStorageFile;

    var supportsBinaryString = false;
    try  {
        window.localStorage.setItem("__test__", String.fromCharCode(0xD800));
        supportsBinaryString = window.localStorage.getItem("__test__") === String.fromCharCode(0xD800);
    } catch (e) {
        supportsBinaryString = false;
    }
    exports.LocalStorage = supportsBinaryString ? LocalStorageModern : LocalStorageOld;

    browserfs.registerFileSystem('LocalStorage', exports.LocalStorage);
});
//# sourceMappingURL=localStorage.js.map
;